__turbopack_context__.v({
  "BGPattern": "Interconnection-module-scss-module__jNqXCa__BGPattern",
  "bottomPartWrapper": "Interconnection-module-scss-module__jNqXCa__bottomPartWrapper",
  "circle": "Interconnection-module-scss-module__jNqXCa__circle",
  "circleCenter": "Interconnection-module-scss-module__jNqXCa__circleCenter",
  "circleLine": "Interconnection-module-scss-module__jNqXCa__circleLine",
  "container": "Interconnection-module-scss-module__jNqXCa__container",
  "content": "Interconnection-module-scss-module__jNqXCa__content",
  "even": "Interconnection-module-scss-module__jNqXCa__even",
  "line": "Interconnection-module-scss-module__jNqXCa__line",
  "lineElement": "Interconnection-module-scss-module__jNqXCa__lineElement",
  "lineElementWrapper": "Interconnection-module-scss-module__jNqXCa__lineElementWrapper",
  "lineSmallCircle": "Interconnection-module-scss-module__jNqXCa__lineSmallCircle",
  "midPartWrapper": "Interconnection-module-scss-module__jNqXCa__midPartWrapper",
  "numerate": "Interconnection-module-scss-module__jNqXCa__numerate",
  "odd": "Interconnection-module-scss-module__jNqXCa__odd",
  "partContent": "Interconnection-module-scss-module__jNqXCa__partContent",
  "segment1": "Interconnection-module-scss-module__jNqXCa__segment1",
  "segment2": "Interconnection-module-scss-module__jNqXCa__segment2",
  "segment3": "Interconnection-module-scss-module__jNqXCa__segment3",
  "segment4": "Interconnection-module-scss-module__jNqXCa__segment4",
  "segment5": "Interconnection-module-scss-module__jNqXCa__segment5",
  "segment6": "Interconnection-module-scss-module__jNqXCa__segment6",
  "segments": "Interconnection-module-scss-module__jNqXCa__segments",
  "topPartWrapper": "Interconnection-module-scss-module__jNqXCa__topPartWrapper",
});
